import Icon1 from "../../assets/icons/FeaturesIcons/Group (1).png";
import Icon2 from "../../assets/icons/FeaturesIcons/Group (2).png";
import Icon3 from "../../assets/icons/FeaturesIcons/Group (3).png";
import Icon4 from "../../assets/icons/FeaturesIcons/Group (4).png";
import Icon5 from "../../assets/icons/FeaturesIcons/Group (5).png";
import Icon6 from "../../assets/icons/FeaturesIcons/Group (6).png";
import Icon7 from "../../assets/icons/FeaturesIcons/Group (7).png";
import Icon8 from "../../assets/icons/FeaturesIcons/Group (8).png";

const Features = () => {
  const educatorTools = [
    {
      id: "cyclogram",
      icon: <img src={Icon1} />,
      title: "Жылдық жұмыс жоспары",
    },
    {
      id: "perspective-plan",
      icon: <img src={Icon2} />,
      title: "Әдістемелік нұсқаулар",
    },
    {
      id: "value-map",
      icon: <img src={Icon3} />,
      title: "Тақырыптық жоспарлар",
    },
    {
      id: "fairy-tales",
      icon: <img src={Icon4} />,
      title: "Семинарлық жоспарлар",
    },
    {
      id: "interactive-tales",
      icon: <img src={Icon5} />,
      title: "Мониторинг және талдау құжаттары",
    },
    {
      id: "observation-sheet",
      icon: <img src={Icon6} />,
      title: "Педагоготардың кәсіби өсуін жоспарлау құжаттары",
    },
    {
      id: "dev-books",
      icon: <img src={Icon7} />,
      title: "Ата-анамен жұмыс жоспары ",
    },
    {
      id: "notable-dates",
      icon: <img src={Icon8} />,
      title: "Бақылау парақшалары",
    },
  ];

  return (
    <section id="tarbieshi-bolimi" className="py-8 md:py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#674DA2] mb-6">
            Әдістемелік Құжаттар
          </h2>
          <p className="text-lg md:text-xl  leading-relaxed">
            Ustaz Kids – әдістемелік құжаттар, жоспарлау үлгілері, мониторинг
            құралдары мен тәрбие үдерісін қолдайтын барлық материалдар
            жинақталған орта.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
          {educatorTools.map((tool) => (
            <a
              key={tool.id}
              href={tool.href}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center transform hover:-translate-y-2 group border-2 border-transparent hover:border-[#F3DA6D]"
            >
              <div className="w-16 h-16 bg-[#674DA2]/10 rounded-full mb-5 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                <img
                  src={tool.icon.props.src}
                  alt={tool.title}
                  className="w-8 h-8 object-contain"
                />
              </div>
              <h3 className="text-sm md:text-lg font-semibold  group-hover:text-[#674DA2] transition-colors duration-300">
                {tool.title}
              </h3>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Features;
